import { render, staticRenderFns } from "./SignatureConfigView.vue?vue&type=template&id=071bd5f4"
import script from "./SignatureConfigView.vue?vue&type=script&lang=js"
export * from "./SignatureConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports